import { Component, OnInit } from '@angular/core';
import { MustahzarService } from '../_services/mustahzar.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-mustahzar',
  templateUrl: './mustahzar.component.html',
  styleUrls: ['./mustahzar.component.css']
})
export class MustahzarComponent implements OnInit {

  constructor(private promptService:MustahzarService,private modal: NgbModal) { }
  labels:any[]=[];
  page=1;
  ngOnInit() {
    this.getPrompts();
  }


  getPrompts(){
      this.promptService.getMustahzar(this.page).subscribe(res=>{
        this.labels=res;
      });
  }


  prev(){
    if(this.page>1)
      this.page--;
    this.getPrompts();

  }

    next(){
      this.page++;
      this.getPrompts();
    
  }
}
